import { Component, OnInit, Input, Output, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl
} from "@angular/forms";
import {
  FieldWrapper,
  KreFormFieldConfig,
  KreTableFieldConfig
} from "@kre-form/core";
import { ModalController, NavParams } from "@ionic/angular";

@Component({
  selector: "kreform-lookup-employee",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"]
})
export class KreFormLookUpEmployee implements OnInit {
  @Input() fieldConfig: KreFormFieldConfig;
  constructor(private modalController: ModalController) {}
  ngOnInit() {}

  dismissModal() {
    this.modalController.dismiss({
      dismissed: true,
      selected: "1,2,3,4"
    });
  }
}
